import {SPECTATOR_COLOR} from "../constants/players.js";
import {CONTROLS_COLOR} from "../styles/constants.js";

export const PLAYER_COLORS = {
  BLUE: 'blue',
  INDIGO: 'indigo',
  SKY_BLUE: 'sky_blue',
  CELADON: 'celadon',
  LIGHT_GREEN: 'light_green',
  DARK_GREEN: 'dark_green',
  VIOLET: 'violet',
  PURPLE: 'purple',
  PINK: 'pink',
  GREY: 'grey',
  LIGHT_GREY: 'light_grey',
  RED: 'red',
  YELLOW: 'yellow',
  ORANGE: 'orange',
  BONE: 'bone',
  LIGHT_BROWN: 'light_brown',
  BROWN: 'brown',
  NEUTRAL: 'neutral',
  SPECTATOR_COLOR: SPECTATOR_COLOR,
}

export const COLORS_CONFIG = {
  [PLAYER_COLORS.BLUE]: '#3a7cbd',
  [PLAYER_COLORS.INDIGO]: '#4455ff',
  [PLAYER_COLORS.SKY_BLUE]: '#56b4ff',
  [PLAYER_COLORS.CELADON]: '#00cfc1',
  [PLAYER_COLORS.LIGHT_GREEN]: '#7bbf34',
  green: '#006825',
  [PLAYER_COLORS.DARK_GREEN]: '#249145',
  [PLAYER_COLORS.VIOLET]: '#7b00d1',
  [PLAYER_COLORS.PURPLE]: '#9e0076',
  [PLAYER_COLORS.PINK]: '#ff67dc',
  [PLAYER_COLORS.GREY]: '#757575',
  [PLAYER_COLORS.LIGHT_GREY]: '#a1a1a1',
  [PLAYER_COLORS.RED]: '#d30023',
  [PLAYER_COLORS.YELLOW]: '#F5CC00',
  [PLAYER_COLORS.ORANGE]: '#e68b01',
  [PLAYER_COLORS.BONE]: '#ccb5a2',
  [PLAYER_COLORS.LIGHT_BROWN]: '#af7745',
  [PLAYER_COLORS.BROWN]: '#884800',
  [PLAYER_COLORS.NEUTRAL]: '#000000',
  [SPECTATOR_COLOR]: CONTROLS_COLOR,
}

/**
 * Малозаметные на поле цвета. Тайлы городов — коричневое дерево, и полоса
 * границы владений (см. addCityBorderMarkers в HexGridRenderer) серого,
 * костяного или коричневого цвета на них почти не читается.
 *
 * Такие цвета не ставят в начало приоритетов фракций и образов (правила — в
 * utils/factions/findColorPriorityIssues.js) и выдают случайным подбором в
 * последнюю очередь (см. pickPlayerColor).
 */
export const LOW_VISIBILITY_PLAYER_COLORS = [
  PLAYER_COLORS.GREY,
  PLAYER_COLORS.LIGHT_GREY,
  PLAYER_COLORS.BONE,
  PLAYER_COLORS.LIGHT_BROWN,
  PLAYER_COLORS.BROWN,
];

/**
 * Малозаметен ли цвет игрока на поле (см. LOW_VISIBILITY_PLAYER_COLORS)
 * @param {string} color
 * @returns {boolean}
 */
export const checkIfLowVisibilityPlayerColor = (color) => LOW_VISIBILITY_PLAYER_COLORS.includes(color);
